import { Button, cn } from "@cronika/ui";
import { FC, ReactNode } from "react";

type TQuickButtonProps = {
  children: ReactNode;
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

/**
 * Single cell of the "Quick" preset grid. One component, three visual states:
 * normal (outlined), selected (accent fill) and disabled (dimmed). Shared by
 * both Duration and Time modes so the grids stay visually consistent.
 */
export const QuickButton: FC<TQuickButtonProps> = ({ children, active, disabled, onClick }) => (
  <Button
    size="sm"
    disabled={disabled}
    onClick={() => !disabled && onClick?.()}
    className={cn(
      "h-11 rounded-xl border border-white/[0.08] bg-white/[0.03] text-sm font-medium text-quick-label",
      !active && !disabled && "hover:bg-white/[0.06]",
      active && !disabled && "!border-transparent !text-black [background:var(--gradient-accent-quick)]",
      disabled && "!opacity-30 !cursor-not-allowed",
    )}
  >
    {children}
  </Button>
);
